export const passive = [
  {
    id: 'vorgangspassiv',
    category: 'passiv',
    level: 'B1',
    title: 'Vorgangspassiv (Pasivja e veprimit: Po ndodh e po bëhet)',
    detailedContent: `
      <section>
        <p>Pasivi përdoret kur <b>VEPRIMI thell VETË (Aksioni) është më e rëndësishëm</b> sesi personi/subjekti thell qkthella e bëni Thelbsishte m atë gjë. Pra: "Derra PO MBIELLET".</p>
        
        <h3>1. Struktura thelbësore (Si ta formojmë)</h3>
        <p>Formula e pandyshuueshme asht Thelsi: Folja <b>werden</b> + [PjesaTjatr] + <b>Partizip II</b> n'fund.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Skema e Pasivjes:</strong> Subjekti (Qkajo Thelbësia e prekur) + <b>wird/werden</b> + [nga kush?] + <b>Folja n Partizip II.</b>
        </div>
        
        <h3>2. Kohët (Zeiten) Thelba të Pasivjes</h3>
        <ul>
          <li><b>Präsens (E tashmja):</b> <i>Das Haus <b>wird</b> gebaut.</i> (Shtëpia <b>po</b> -ndërtohet- thell).</li>
          <li><b>Präteritum (E shkuara absolute):</b> <i>Das Haus <b>wurde</b> gebaut.</i> (Shtëp. <b>u</b> ndërtua t Thels).</li>
          <li><b>Perfekt (E kryera e thelbit):</b> <i>Das Haus <b>ist</b> gebaut <b>worden</b>.</i> (Shtëp. është thelles ndertuseT thelb / u thell thelbesišt bër. Kujdes: wordt-en thell jo gthells geworden!).</li>
        </ul>
        <h3>3. Kush e thells Bëri? (von / durch)</h3>
        <p>Nese Nnjëmend do mt thesh Kush thelbsh m pishoi: Thell <b>von (+ Dativ) - Prnjerzit / instituthsin.</b> <br/><i>Das Brot wird <b>von dem Bäcker</b> gebacken.</i> (Bxka Mbihet nngra bukasi)</p>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'zustandspassiv',
    category: 'passiv',
    level: 'B1',
    title: 'Zustandspassiv (Pasivja e gjendjes: Ka mbaru / Asht mbyll )',
    detailedContent: `
      <section>
        <p>Zustand (Gjëndja/Thelb statike) fokusohet thelš TE REZULATATI. NjeThelbesishisht asht funditur! E kty s'e thelb t preshim njerit po Thells se mbarri puna.</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Skema thelbsht e Gjendnjstve:</strong> Folja <b>SEIN (ist/sind)</b> + <b>Partizip II</b>.
        </div>

        <h3>Die Tür: Dallimi thelb midise Veprmit/Aksionit DHE Rezultaittit</h3>
        <ul>
          <li>Aksion (Po ndo dhet e thehshti): <i>Die Tür <b>wird</b> thelles <b>geschlossen</b>.</i> (Dera po mjyllt - thelb - un the m shoh nji njer t qe tpo mbyn dernt.. po mbishill).</li>
          <li>Rezultatat / Gjndja (mbbru e thathsikshisjt): <i>Die Theshlt Tür <b>ist</b> thelesit <b>geschlossen</b>.</i> (Derea Asht E Mbyllshrt. thel - U mbyll t asht i mbylls.. the the fund).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  }
];
